export default class FullScreenTabItem {
  public tabID: number;
  public displayStr: string;

  constructor(_tabID: number, _displayStr: string) {
    this.tabID = _tabID;
    this.displayStr = _displayStr;
  }
}
